<div class="viewer-wrapper" dir="rtl">
  @if (loading()) {
    <div class="loading-state">
      <div class="spinner-border text-success" role="status"></div>
      <p class="mt-2 text-muted">Loading Quran Pages...</p>
    </div>
  }
  @if (errorMsg()) {
    <div class="alert alert-danger m-4 w-100 text-center">{{ errorMsg() }}</div>
  }

  <div class="carousel-container" [style.visibility]="loading() ? 'hidden' : 'visible'">
    <div class="carousel-inner-wrapper">
      
      <!-- Navigation Right (Previous Page in RTL) - Renders on RIGHT -->
      <button class="nav-btn prev-btn" (click)="prevPage()" [class.disabled]="currentPage() <= 1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <!-- Swiper Web Component -->
      <swiper-container init="false" #swiperContainer class="mySwiper">
        <swiper-slide *ngFor="let p of pages()" class="pdf-slide">
          <div class="swiper-zoom-container slide-content">
            <img [id]="'page-img-' + p" class="quran-page-img" />
            <canvas [id]="'page-canvas-' + p" style="display: none;"></canvas>
          </div>
        </swiper-slide>
      </swiper-container>

      <!-- Navigation Left (Next Page in RTL) - Renders on LEFT -->
      <button class="nav-btn next-btn" (click)="nextPage()" [class.disabled]="currentPage() >= pages().length">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

    </div>
  </div>

  <!-- Custom Timeline Pagination -->
  <div class="timeline-container" [style.visibility]="loading() ? 'hidden' : 'visible'">
    <div class="timeline-line"></div>
    <div class="timeline-nodes">
      <!-- Show surrounding pages in timeline -->
      <ng-container *ngFor="let p of getTimelinePages()">
        <div class="timeline-node-wrapper" (click)="goToPage(p)">
          <div class="timeline-dot" [class.active]="p === currentPage()"></div>
          <div class="timeline-label" [class.active-label]="p === currentPage()">رقم الصفحة <br> {{ p }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
